const catalogContainer = document.querySelector("[data-catalog]");

(() => {
    // Used by both the internal /catalog/ page and public "browse" products.
    // On the internal catalog WordPress enqueues this file normally; on a public
    // browse page it is injected by gate.js once the form has been submitted.
    loadDriveWorksClient();
})();

async function startClientFunctions() {
    try {
        // Create CPQ DriveApp Specification
        const specification = await DW_CLIENT.runDriveApp(GROUP_ALIAS, DRIVE_APP_NAME);
        localStorage.setItem("catalog.Id", specification.id);

        // Used by ensureOrderId(), and to list the CPQ constant names from the
        // browser console - see dwListConstants().
        window.DW_SPECIFICATION = specification;
        // Set catalog state
        console.log("%cSET CATALOG DATA", "color: violet;");
        await Promise.all([
            setTeamId(specification),
            setConstant(specification, "Type", "Catalog"),
            setConstant(specification, "Name", CATALOG_NAME),
        ]);
        await runMacro(specification, "SetMode", "Add");

        // Render Specification
        catalogContainer.style.height = config.configuratorHeight.catalog + "px";
        catalogContainer.innerHTML = "";
        await specification.render(catalogContainer);
        console.log("Rendered Specification");

        // Keep Specification alive without activity
        pingSpecification(specification);

        // Listen for value changes
        specification.registerConstantValueChangedDelegate(data => constantChanged(data));
        specification.registerVariableValueChangedDelegate(data => variableChanged(data));

        // Set order id (change watched above)
        //
        // MUST stay after the delegates are registered: setting ParameterOrderId
        // is what makes DriveWorks push TotalCount back, which is how the basket
        // count in the header and the "Item added to basket" message are
        // updated. The catalog never creates orders, so there is nothing to gain
        // from running this earlier - see setOrderId().
        await setOrderId(specification);
    } catch (error) {
        console.log(error);
    }
}

async function constantChanged(data) {
    const name = data.constantName.replace("DWConstant", "");
    const value = data.constantValue;

    console.log("Constant changed", data);

    switch (name) {
        case "ParameterOrderId":
            console.log ("ParameterOrderId")
            const orderId = localStorage.getItem("orderId");
            const newOrderId = value;
            if (orderId === newOrderId) {
                console.log("old orderId and newOrderId match");
                return;
            }
            console.log("old orderId and newOrderId DONT match");
            localStorage.setItem("orderId", value);
            //location.href = "basket.html";
            location.href = DriveworksData.basket_url;
            
        case "RedirectAction":
            console.log ("RedirectAction")

            // The order id may not have been pushed to us yet - see
            // ensureOrderId() in dw-client-functions.js.
            if (value === "Add") {
                await ensureOrderId();
            }

            const orderId2 = localStorage.getItem("orderId");
            
            // Redirect to basket
            if (value === "Add") {
                if (orderId2) {
                    //location.href = "basket.html";
                    if (window.location.pathname === '/catalog/') {
                        localStorage.setItem("DW_Catalog_Message", "Item added to basket");
                        location.href = "/catalog/";
                    }
                    else{
                        location.href = DriveworksData.basket_url;
                    }

                    
                }

                // location.href = "basket.html";
            }
            
        default:
            break;
    }
}

function variableChanged(data) {
    const name = data.variableName.replace("DWVariable", "");
    const value = data.variableValue;

    console.log("Variable changed", data);

    switch (name) {
        case "TotalCount":
            setStoredBasketQuantity(value);
            showCatalogMessage();
            console.log("WTM: TotalCount changed", value);
            break;
        default:
            break;
    }
}

function setStoredBasketQuantity(value) {
    localStorage.setItem("basketQuantity", value);
    site.displayBasketQuantity();
}


/* Show a message on catalog page when a product is added to the basket from the catalog */
function showCatalogMessage() {
    const message = localStorage.getItem("DW_Catalog_Message");
    if (!message) return;

    const container = document.getElementById("driveworks-message-container");
    const messageElement = document.getElementById("driveworks-message");
    if (!container) return;

    messageElement.textContent = message;
    container.style.display = "block";

    localStorage.removeItem("DW_Catalog_Message");
}
// Run on load
//document.addEventListener("DOMContentLoaded", showCatalogMessage);